var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className},[_c('img',{class:[
      _vm.imgDesktopClassName,
      _vm.imgClassName ],attrs:{"src":_vm.bgImage,"alt":_vm.imgAlt}}),_c('img',{class:[
      _vm.imgMobileClassName,
      _vm.imgClassName ],attrs:{"src":_vm.mobileBgImage,"alt":_vm.imgAlt}})])}
var staticRenderFns = []

export { render, staticRenderFns }